import React from 'react';
import {PostDemandContent} from './sub-view/post-demand-content';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessPostDemandContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active="post-demand">
        <h1 className="user-header">Gửi nhu cầu</h1>
        <PostDemandContent/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessPostDemandContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessPostDemandContainer.jsx